const {default: useStore} = require('./use-store.js');

const useCategories = () => {
    const {store} = useStore();

    return {categoryStore: store.categories};
};

export default useCategories;
